import React from 'react';

import { Divider, Stack } from '@mui/material';

import CustomClaimsField from './CustomClaimsField';
import ExternalIdentitiesField from './ExternalIdentitiesField';

type Props = {
  user: App.User;
  update: (user: App.User) => void;
};

export default function SecurityTab({ user, update }: Props) {
  return (
    <Stack spacing={4} sx={{ mt: 4 }}>
      <ExternalIdentitiesField accountId={user.id_member} />
      <Divider />
      <CustomClaimsField
        accountId={user.id_member}
        customClaims={user.custom_claims}
        onUserPatched={(updatedUser) =>
          update({
            ...user,
            ...updatedUser,
            custom_claims: updatedUser.custom_claims ?? user.custom_claims,
          })
        }
      />
    </Stack>
  );
}
